import { getEventBusIfDefined } from '@cian/event-bus';

require('./style.css');

import {
  reloadHeader,
  setActiveBottomMenuItem,
  submitGA,
  submitMobileMenuGA,
  updateFavorites,
  waitForLoginPopup,
  initializeStuff,
  setActiveNewBottomMenuItem,
  removeRedwareCookies,
} from './util';
import { initializeGeoSwitcher } from './services/geoSwitcher';
import { setFingerprintCookie } from './utils/fingerprint';
import { IHeaderV1Schema } from '../shared/repositories/header/entities/response/HeaderV1Schema';
import { initializeChatsNotificator, initializeChatsCounter } from './services/chats';
import { handleDownloadAppClick } from './utils/handleDownloadAppClick';
import { getConfig } from '@cian/config/browser';
import {
  initializeCheckAnounceRelevancePopup,
  initializeProlongationPopup,
  initializeModerationCheckConstraint,
} from './services/moderation';
import { initializeBackToAdPopup } from './services/backToAdPopup';
import { initializeGroupIcons } from './services/groupIcons';
import { initializeNotificationCenter } from './services/notificationCenter';
import { initializeUserMenu } from './services/userMenu';
import { initializeDropdownMenus, initializeNewTopMenu } from './services/dropdownMenus';
import { initializeSpecialPromoLink } from './services/specialPromoLink';

const burger = document.getElementById('burger');
const menuBg = document.getElementById('nav-bg');
const closeButton = document.getElementById('nav-close');
const downloadAppButton = document.getElementById('download-app');
const adaptiveMenu = document.getElementById('adaptive-menu');
const menu = document.getElementById('adaptive-header');
const body = document.querySelector('body');
const html = document.documentElement;

let htmlOverflow = '';
let bodyOverflow = '';

if (burger) {
  burger.onclick = () => {
    if (burger && adaptiveMenu && menu && body) {
      adaptiveMenu.className += ' c-header__main-nav-opened';
      adaptiveMenu.classList.remove('c-header__main-nav-hidden');
      menu.className += ' c-header-opened';
      htmlOverflow = html.style.overflow;
      bodyOverflow = body.style.overflow;
      // Если не скрывать переполнение для html - скрытие не работает должным образом на ios
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    }
  };
}

const closeMenu = () => {
  if (adaptiveMenu && menu) {
    adaptiveMenu.classList.remove('c-header__main-nav-opened');
    menu.classList.remove('c-header-opened');
    setTimeout(() => {
      if (adaptiveMenu && body) {
        adaptiveMenu.className += ' c-header__main-nav-hidden';
        html.style.overflow = htmlOverflow;
        body.style.overflow = bodyOverflow;
      }
    }, 300);
  }
};

if (menuBg) {
  menuBg.onclick = closeMenu;
}

if (closeButton) {
  closeButton.onclick = closeMenu;
}

if (downloadAppButton) {
  downloadAppButton.onclick = handleDownloadAppClick;
}

window.onload = () => {
  const config = getConfig();
  const headerData = config.getStrict<IHeaderV1Schema>('headerData');
  const newHeaderEnabled = config.get<boolean>('newHeaderEnabled') as boolean;
  const isAdaptive = config.get<boolean>('isAdaptive');
  const userIsAuthenticated = config.get<boolean>('userIsAuthenticated') as boolean;

  setFingerprintCookie();
  removeRedwareCookies();
  initializeGeoSwitcher();

  //на всякий случай решил подстраховаться
  //непонятно зачем initializeDropdownMenus в setTimeout 1000
  let dropdownInitialized = false;
  if (window.__header_dropdown_menus_data__) {
    initializeDropdownMenus({
      newHeaderEnabled,
      headerData,
    });
    dropdownInitialized = true;
  }

  initializeNewTopMenu({
    newHeaderEnabled,
    headerData,
  });
  initializeStuff();

  return setTimeout(() => {
    if (!dropdownInitialized) {
      initializeDropdownMenus({
        newHeaderEnabled,
        headerData,
      });
    }
    initializeNewTopMenu({
      newHeaderEnabled,
      headerData,
    });
    initializeSpecialPromoLink(newHeaderEnabled);
    initializeModerationCheckConstraint();
    initializeCheckAnounceRelevancePopup();
    initializeProlongationPopup();

    if (userIsAuthenticated) {
      initializeChatsNotificator();
    }
    if (newHeaderEnabled) {
      initializeGroupIcons(headerData);
    }

    if (isAdaptive) {
      initializeChatsCounter();
    }

    initializeBackToAdPopup();
    initializeUserMenu(headerData);
    initializeNotificationCenter();
  }, 1000);
};

const eventBus = getEventBusIfDefined();
if (eventBus) {
  eventBus.subscribe('header:category_changed', (event: CianEventBus.IEvent) => {
    const newHeaderEnabled = getConfig().get<boolean>('newHeaderEnabled') as boolean;

    if (newHeaderEnabled) {
      setActiveNewBottomMenuItem(event.type);
    } else {
      setActiveBottomMenuItem(event.type);
    }
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).reloadHeader = reloadHeader;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__reloadHeader__ = reloadHeader;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).refreshAfterUserLoggedIn = reloadHeader;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any)._headerTrackingEvent = submitGA;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any)._mobileMenuTrackingEvent = submitMobileMenuGA;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).waitForLoginPopup = waitForLoginPopup;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__header_updateFavorites__ = updateFavorites;
